interface AusentismoTableProps {
  columns: { label: string; key?: string; sortable?: boolean }[];
  children: React.ReactNode;
  onSort?: (key: string) => void;
  sortBy?: string;
  order?: "ASC" | "DESC";
}

const AusentismoTable: React.FC<AusentismoTableProps> = ({
  columns,
  children,
  onSort,
  sortBy,
  order,
}) => {
  return (
    <div
      className="my-3"
      style={{
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e5e7eb",
      }}
    >
      <div
        className="invisible-scroll"
        style={{
          maxHeight: "65vh",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        <table
          className="table table-hover text-nowrap align-middle mb-0 bg-white"
          style={{ fontSize: "0.8rem", borderRadius: "16px" }}
        >
          <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
            <tr className="bg-light border-bottom">
              {columns.map((col, index) => (
                <th
                  key={index}
                  className={`py-3 px-4 border-0 text-start ${
                    col.sortable ? "cursor-pointer" : ""
                  }`}
                  onClick={() =>
                    col.sortable && col.key && onSort && onSort(col.key)
                  }
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#374151",
                    fontWeight: 700,
                    fontSize: "0.8rem",
                    letterSpacing: "0.025em",
                    cursor: col.sortable ? "pointer" : "default",
                  }}
                >
                  <div className="d-flex align-items-center">
                    {col.label}
                    {col.sortable && col.key === sortBy && (
                      <i
                        className={`fa-solid fa-sort-${
                          order === "ASC" ? "up" : "down"
                        } ms-2 text-primary`}
                      />
                    )}
                    {col.sortable && col.key !== sortBy && (
                      <i className="fa-solid fa-sort ms-2 text-muted opacity-25" />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};

export default AusentismoTable;
